// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldBinaryOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldBinaryOutlined";
import AntdIcon from '../components/AntdIcon';

var FieldBinaryOutlined = function FieldBinaryOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldBinaryOutlinedSvg
  }));
};

FieldBinaryOutlined.displayName = 'FieldBinaryOutlined';
export default React.forwardRef(FieldBinaryOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FieldBinaryOutlined.js
// module id = 1077
// module chunks = 0